<template>
    <div class="animated fadeIn custom-cases bgV2">
        <div class="d-flex headerOrderDetail">
            <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
                <div class="mt-20 pl-20">
                    <h1 class="mb-1">{{item.approval_request_number}}</h1>
                </div>
                <h4 class="c-orange mb-0" v-if="item.id">{{item.status}}</h4>
            </div>
        </div>
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <template v-if="is_supplier">
                            <gofix-button
                                v-if="item && (item.status == 'Draft' || (item.status == 'Pending Revision' && item.current_approval_level == -1 && item.created_by == User.id))"
                                class="mr-2"
                                :disabled="!$checkRole($accessModule.approval_request, 'update')"
                                :loading="loadingSubmit"
                                @click="submit"
                                label="SUBMIT APPROVAL REQUEST"
                                outline>
                            </gofix-button>
                            <gofix-button
                                :disabled="(!$checkRole($accessModule.approval_request, 'update') || item && ((item.status != 'Draft' && item.status != 'Pending Revision') || (item.current_approval_level !== -1 && item.current_approval_level !== null) || item.created_by != User.id))"
                                :loading="loadingSave"
                                @click="save"
                                label="SAVE">
                            </gofix-button>
                        </template>
                        <template v-else>
                            <gofix-button
                                v-b-tooltip.hover
                                :title=" approverCurrent.user && item.status === 'Under Approval' ? 'To be approved by: ' + approverCurrent.user : ''"
                                v-if="item.status === 'Under Approval' || (ApprovalLogs && ApprovalLogs.total && item.status !== 'Draft')"
                                :label="(item.status === 'Under Approval' || item.status === 'Pending Revision') ? 'APPROVAL' : 'APPROVAL LOG'"
                                class="ml-3"
                                @click="openModalApproval" 
                                outline>
                            </gofix-button>
                        </template>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card title=" " classContent="mb-0" :class="{'run-loading': loadingDetail}">
                            <b-row align-v="center">
                                <b-col md="4">
                                    <gofix-form-input disabled label="Town Council" v-model="item.towncouncil"></gofix-form-input>
                                    <!-- <gofix-form-dropdown
                                        label="Town Council"
                                        vLabel="contract_name"
                                        :filterable="false"
                                        :append-to-body="true"
                                        :required="true"
                                        :options="options.contracts"
                                        @search="searchContract"
                                        v-model="item.contract"
                                        @change="selectContract">
                                    </gofix-form-dropdown> -->
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input disabled label="Lift Code" v-model="item.lift_code"></gofix-form-input>
                                    <!-- <gofix-form-dropdown
                                        :class="[{'run-loading small-loading': options.loading.equipments}]"
                                        label="Lift Code"
                                        v-model="item.equipment"
                                        vLabel="tag_name"
                                        :disabled="false"
                                        required
                                        :options="options.equipments"
                                        @search="searchEquipment"
                                        :clearable="false" 
                                        :filterable="false"
                                        @change="selectEquipment">
                                    </gofix-form-dropdown> -->
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input label="Requestor Name" v-model="item.requested_name" disabled></gofix-form-input>
                                </b-col>
                                <b-col md="2">
                                    <gofix-form-input label="Requestor Contact No" v-model="item.requested_contact_no" disabled></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="2">
                                    <gofix-text-field class="mb-26" label="Lift No" oneline>{{ item.lift_number }}</gofix-text-field>
                                </b-col>
                                <b-col md="2">
                                    <gofix-text-field class="mb-26" label="Block No" oneline>{{ item.blk_number }}</gofix-text-field>
                                </b-col>
                                <b-col md="2">
                                    <gofix-text-field class="mb-26" label="Postal Code" oneline>{{ item.postal_code }}</gofix-text-field>
                                </b-col>
                                <b-col md="2">
                                    <gofix-text-field class-label="width-99" class="mb-26" label="Department" oneline>{{ item.request_name ?item.request_name.department : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="2">
                                    <gofix-text-field class="mb-26" label="Company Name" oneline>{{ item.supplier ? item.supplier.name : '' }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col class="mb-1" md="3">
                                    <gofix-form-input label="Fault Event Number" v-model="item.fault_event_number" maxlength="25" required show-icon-required></gofix-form-input>
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-input label="Part Location" v-model="item.part_location"></gofix-form-input>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field class-label="width-99" class="mb-26" label="Location" oneline>{{ item.location }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="8">
                                    <gofix-form-input-textarea :rows="6" label="Description Of Replacement Work For Approval" v-model="item.description"></gofix-form-input-textarea>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <line-items ref="lineItems" :is_supplier="is_supplier"></line-items>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <Activities ref="itemActivities" activityType="Approval Request" :activityId="$route.params.id" :controls="controls" name-table="lmu-approval-request-activity-log"/>
                    </template>
                    <template slot="gofixTab:attachment">
                        <gofix-attachment :Item="item" :attachable_type="'defect_report'" classCard="mb-0" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>

        <!-- Modal: Approval -->
        <b-modal
            :no-close-on-backdrop="true"
            id="modal-order-approval-log"
            modal-class="modals-approval gofixModal"
            size="lg"
            :title="(item.current_approval_level != -1 && (item.status === 'Under Approval' || item.status === 'Pending Revision')) ? 'Approval' : 'Approval Log'"
            hide-footer
            :centered="true"
            ref="modal-approval-log"
            v-model="modals.approval_log.open"
            @hidden="approvalLogObj.remark = null">
            <!-- Action & Remarks -->
            <template v-if="item && item.current_approval_level != -1 && (item.status === 'Under Approval' || item.status === 'Pending Revision')">
                <div class="actionAndRemarks modalPadding" v-bind:class="{'disabled-block': (item.status === 'Rejected' || (!approvalData.approval && (item && item.current_approval_level != null && item.current_approval_level >= 0 )))}">
                    <b-row>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field label="Next Approver" oneline>
                                <span class="pl-20" v-if="approvalData.limit && checkInRoleApproval()">--</span>
                                <span class="pl-20" v-else>{{approverNext.limit| formatMoney}} - {{approverNext.user}}</span>
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field label="Current Approver" oneline>
                                <span>{{approverCurrent.limit| formatMoney}} - {{approverCurrent.user ? approverCurrent.user : ''}}</span>
                            </gofix-text-field>
                        </b-col>
                        <b-col md="9" class="">
                            <gofix-form-input-textarea label="remarks" class="mb-0 h-100" v-model="approvalLogObj.remark" />
                        </b-col>
                        <b-col md="3" class="action">
                            <gofix-button
                                class="d-block mb-2 w-100"
                                :label="item && item.status === 'Pending Revision' ? 'Revision Applied' : (item && item.status === 'Submitted' ? 'Request for Approval' : 'Recommend for Approval')"
                                @click="approvalLog('Recommend for Approval')"
                                v-if="!approvalData.limit"
                                :disabled="(!approvalData.approval && item && item.current_approval_level !== null && item.current_approval_level >= 0 ) || !item.approval_levels.length || modals.approval_log.loading"
                                outline />
                            <gofix-button
                                class="d-block mb-2 w-100"
                                label="Approve"
                                @click="approvalLog('Approval')"
                                v-if="approvalData.limit"
                                :disabled="!approvalData.approval || modals.approval_log.loading"
                                outline />
                            <gofix-button
                                class="d-block mb-2 w-100"
                                label="Request for Revision"
                                @click="approvalLog('Request for Revision')"
                                v-if="(item && item.current_approval_level != -1)"
                                :disabled="!approvalData.approval || modals.approval_log.loading"
                                outline />
                            <gofix-button
                                v-if="item && approvalData.approval"
                                class="d-block w-100"
                                label="Reject"
                                @click="approvalLog('Reject')"
                                :disabled="!approvalData.approval || modals.approval_log.loading"
                                outline dark />
                            <gofix-button
                                v-if="item && (item.status === 'Under Approval' || item.status === 'Pending Revision') && !approvalData.approval"
                                :disabled="!approvalData.approval && (item && item.current_approval_level != null && item.current_approval_level >= 0 )"
                                class="d-block w-100"
                                label="Cancel"
                                @click="modals.approval_log.open = false"
                                outline dark />
                        </b-col>
                    </b-row>
                </div>
                <hr/>
            </template>
            <b-row>
                <b-col md="12" class="mb-3" v-if="item && item.current_approval_level != -1 && (item.status === 'Under Approval' || item.status === 'Pending Revision')">
                    <h5 class="modalTitle modalPadding">Approval Log</h5>
                </b-col>
                <b-col md="12">
                    <div class="gofixBasicTable approvalLogTable">
                        <div class="dataList">
                            <vue-scrollbar class="tableList">
                                <b-table :fields="fields" :items="ApprovalLogs.data" class="table-has-fixed" fixed>
                                    <template slot="finance_limit" slot-scope="row">
                                        {{ row.item.finance_limit | formatMoney}}
                                    </template>
                                    <template slot="log_time" slot-scope="row">
                                        {{ row.item.log_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                                    </template>
                                </b-table>
                            </vue-scrollbar>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const LineItems = () => import('./line_items.vue')
    const Activities = () => import("../global/Activities")
    const Attachment = () => import('@/views/attachments/list_v2')
    import moment from 'moment';
    export default {
        name: 'defect-report-detail',
        components: {
            LineItems,
            Activities,
            Attachment
        },
        props: {
            is_supplier: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                url: this.is_supplier ? 'supplier-portal' : 'v2',
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                    {
                        key: "attachment",
                        title: "Attachments",
                        active: false
                    }
                ],
                loadingSubmit: false,
                loadingSave: false,
                loadingDetail: false,
                item: {
                    id: null,
                    approval_request_number: null,
                    contract: null,
                    towncouncil: null,
                    lift_code: null,
                    postal_code: null,
                    location: null,
                    blk_number: null,
                    lift_number: null,
                    description: null,
                    attachments: [],
                    status: null,
                    current_approval_level: null,
                    part_location: null,
                    fault_event_number: null,
                    requested_name: null,
                    requested_contact_no: null
                },
                options: {
                    equipments: [],
                    contracts: [],
                    loading: {
                        equipments: false,
                        contracts: false
                    }
                },
                timer: {
                    save: null,
                    submit: null
                },
                controls: {
                    create: false,
                    delete: false,
                    update: false
                },
                modals: {
                    approval_log: {
                        open: false,
                        loading: false
                    }
                },
                approvalData:{
                    current:null,
                    limit:false,
                    approval: false
                },
                approvalLogObj:{
                    lmu_approval_request_id : this.$route.params.id,
                    approval_id: null,
                    action:null,
                    remark:null,
                    approval: false,
                    reject: false,
                },
                approverNext: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                // Approval
                approverCurrent: {
                    limit: 0,
                    user: null,
                    ids:[]
                },
                fields:[
                    {
                        key: 'approval_route_level',
                        label: 'Level',
                        thStyle: 'width: auto'
                    },
                    {
                        key: 'finance_limit',
                        label: 'Approval Limit',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'reviewer.name',
                        label: 'Reviewer',
                        thStyle: 'width: 170px'
                    },
                    {
                        key: 'log_time',
                        label: 'Date Time',
                        thStyle: 'width: 170px',
                        formatter :value => {
                            return moment(value,"YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY HH:mm")
                        },
                    },
                    {
                        key: 'action',
                        thStyle: 'width: 170px',
                        label: 'Action',
                    },
                    {
                        key: 'remark',
                        thStyle: 'width: 170px',
                        label: 'Remarks',
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                ApprovalLogs: 'LMUApprovalRequestController/approvalLogs',
                User : 'AuthController/user',
                Defect: 'LMUApprovalRequestController/item',
            })
        },
        created() {
            this.getContracts()
            this.getItem()
            if(!this.is_supplier) this.getApprovalLogs()
            // if(this.ClientContractID && this.ClientContractID.id) {
            //     this.data.town_council = this.ClientContractID
            //     this.getEquipments()
            // }
        },
        methods: {
            /*-- Get Data --------*/
            getItem() {
                this.loadingDetail = true
                this.$store.dispatch( 'LMUApprovalRequestController/getItem', this.$route.params.id)
                .then(response => {
                    this.item = Object.assign(this.item, response)
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                    this.$router.push(`/${this.url}/approval-request`);
                })
            },
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async getEquipments(tag_name = null) {
                this.options.loading.equipments = true
                this.options.equipments = []
                let tableRequest = {
                    filter: {
                        contract_id: this.ClientContractID.id,
                        tag_name: tag_name,
                        is_active: true
                    },
                    limit: 50,
                    isCMS: false,
                    sortColumn: 'tag_name',
                    sortDirection: 'ASC',
                }
                await this.$store.dispatch("PartReplacementController/getEquipment", tableRequest)
                .then(response => {
                    this.options.equipments = response.items;
                    this.options.loading.equipments = false
                }).catch(err => {
                    this.options.loading.equipments = false
                })
            },
            async searchEquipment(search, loading) {
                loading(true)
                if (this.timer.equipments) {
                    clearTimeout(this.timer.equipments);
                    this.timer.equipments = null;
                }
                this.timer.equipments = setTimeout(async () => {
                    try {
                        await this.getEquipments(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },

            /*-- Select Data --------*/
            selectContract(val) {
                this.options.equipments = [];
                if(val) this.getEquipments()
            },
            selectEquipment(val) {
                if(val) {
                    this.item.lift_code = val.tag_name
                    this.item.location = val.location_info
                    if(val.custom_fields) {
                        let custom_fields = val.custom_fields;
                        custom_fields.map(item => {
                            let key = item.attribute.name ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';
                            if(key == 'block_no' || key == 'block_number') key = 'block_number';
                            if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                            if(this.item.hasOwnProperty(key)) {
                                let value = item.value;
                                if(value && item.attribute.type === "DateTime") {
                                    value = moment(value).format("DD.MM.YYYY");
                                }
                                if(value){
                                    this.item[key] = value;
                                }
                            }
                        })
                    }
                } else {
                    this.item.lift_code = null
                    this.item.location  = null
                    this.item.postal_code  = null
                    this.item.block_number = null
                    this.item.lift_number  = null
                }
            },

            /*-- Store Data --------*/
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(async () => {
                    if(!this.item.fault_event_number) {
                        return this.$alertNotification('Fault event number is required', 'danger');
                    }

                    if(this.item.fault_event_number.length > 25) {
                        return this.$alertNotification('Maximum length is 25 characters', 'danger');
                    }

                    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
                    if(format.test(this.item.fault_event_number)) {
                        return this.$alertNotification('Fault event number must not contain special characters', 'danger');
                    }

                    this.loadingSave = true;
                    let objeClone = {
                        id: this.item.id,
                        description: this.item.description,
                        part_location: this.item.part_location,
                        fault_event_number: this.item.fault_event_number,
                    };
                    
                    this.$store.dispatch("LMUApprovalRequestController/updateItem", objeClone)
                    .then(async response => {
                        this.loadingSave = false;
                        this.$alertNotification(this.$notificationV2('editing', 'defect_report'));
                    })
                    .catch(err => {
                        this.loadingSave = false;
                        if( err.response && err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },
            submit() {
                if (this.timer.submit) {
                    clearTimeout(this.timer.submit);
                    this.timer.submit = null;
                }
                this.timer.submit = setTimeout(async () => {
                    if(!this.Defect.fault_event_number) {
                        return this.$alertNotification('Please enter the fault event number field and save it before submitting the approval request', 'danger');
                    }
                    // if(!this.Defect.line_item.length) {
                    //     return this.$alertNotification("Please add at least 1 line item.", "danger");
                    // }
                    this.loadingSubmit = true;
                    let objeClone = {
                        id: this.item.id,
                        status: "Under Approval",
                    };
                    
                    this.$store.dispatch("LMUApprovalRequestController/updateItemStatus", objeClone)
                    .then(async response => {
                        this.loadingSubmit = false;
                        this.getItem()
                        this.$alertNotification(this.$notificationV2('editing', 'defect_report'));
                    })
                    .catch(err => {
                        this.loadingSubmit = false;
                        if( err.response && err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },
            
            /*-- Approval for FM Officer --------*/
            openModalApproval() {
                // if(this.Defect.line_item.length){
                    //check limit again
                    this.getNextApprover()
                    this.checkApprovalAccess(this.item)
                    this.modals.approval_log.open = true
                // }else{
                //     this.$alertNotification("Please add a line item to approve", "warning");
                // }
            },
            checkInRoleApproval(){
                if(!this.approvalData.current || !this.approvalData.current.roles) return false;
                let userRoles = this.User.roles.map(a => a.id);
                let roles     = this.approvalData.current.roles.map(a => a.id);
                const arrTmp  = userRoles.filter(item => roles.includes(item));
                if(arrTmp.length){
                    return true;
                }
                return false
            },
            checkApprovalAccess(val){
                let key = (val.current_approval_level >= 0 && val.current_approval_level !== null) ? val.current_approval_level : 0;
                this.approvalData.current = this.item.approval_levels[key] ? this.item.approval_levels[key] : null;
                if(this.approvalData.current && (this.item.status === "Under Approval" || (this.item.status === "Pending Revision" && val.current_approval_level >= 0))){
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    if(this.approvalData.current && this.approvalData.current.finance_limit >= this.item.total_net_amount){
                      if(this.item.contract && this.item.contract.settings && this.item.contract.settings.is_exclude_1st_level_approver && this.item.created_by === this.User.id){
                        this.approvalData.limit = false;
                      }else{
                        this.approvalData.limit = true;
                      }
                    }else{
                        this.approvalData.limit = false;
                    }
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                        this.approvalData.approval = true;
                    }else{
                        this.approvalData.approval = false;
                    }
                }else if(this.approvalData.current && ((this.item.status === "Pending Revision" && val.current_approval_level === -1))){
                    this.approvalLogObj.approval_id = this.approvalData.current.id;
                    let userRoles = this.User.roles.map(a => a.id);
                    let currentRoles = this.approvalData.current.roles.map(a => a.id);
                    let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                    if(arrTmp.length){
                      this.approvalData.approval = true;
                      if(this.approvalData.current && this.approvalData.current.finance_limit >= this.item.total_net_amount){
                            this.approvalData.limit = true;
                        }else{
                            this.approvalData.limit = false;
                        }
                    }
                }else{
                    this.approvalData.approval = false;
                    this.approvalData.limit = false;
                }
            },
            getNextApprover(){
                this.$store.dispatch("LMUApprovalRequestController/getNextApprover",{
                    defect_report_id: this.$route.params.id,
                })
                    .then(response => {
                        this.approverNext.user = response.next.user_name ? response.next.user_name.join(", ") : null;
                        this.approverNext.ids = response.next.user_ids;
                        this.approverNext.limit = response.next.finance;

                        this.approverCurrent.user = response.current.user_name ? response.current.user_name.join(", ") : null;
                        this.approverCurrent.ids = response.current.user_ids;
                        this.approverCurrent.limit = response.current.finance;
                    })
                    .catch( err => {
                        this.approverNext.user = null;
                        this.approverNext.ids = [];
                        this.approverNext.limit = null;

                        this.approverCurrent.user = null;
                        this.approverCurrent.ids = [];
                        this.approverCurrent.limit = null;
                    })
            },
            getApprovalLogs() {
                this.$store.dispatch("LMUApprovalRequestController/getApprovalLogs",{
                    page:1,
                    limit:-1,
                    filter:{
                        lmu_approval_request_id: this.$route.params.id
                    }
                })
            },
            approvalLog(action) {
                if (!this.approvalData.approval && this.item && this.item.current_approval_level !== null && this.item.current_approval_level >= 0) return;
                if(this.modals.approval_log.loading) return;
                this.modals.approval_log.loading = true;
                let userRoles = this.User.roles.map(a => a.id);
                let currentRoles = this.approvalData && this.approvalData.current && this.approvalData.current.roles ? this.approvalData.current.roles.map(a => a.id) : [];
                let arrTmp = userRoles.filter(item => currentRoles.includes(item));
                if(this.item.status === "Under Approval" && (!this.item.approval_levels || !this.item.approval_levels[0] || !arrTmp.length)){
                    this.$store.dispatch("LMUApprovalRequestController/createApprovalLog",{
                        lmu_approval_request_id : this.$route.params.id,
                        action: "Under Approval",
                        remark: this.approvalLogObj.remark,
                    })
                        .then(response => {
                            this.$alertNotification(this.$notificationV2('adding', 'approval'));
                            this.modals.approval_log.open = false;
                            this.item.status = "Under Approval";
                            this.getItem();
                            this.getNextApprover();
                            this.getApprovalLogs();
                            setTimeout(()=>{
                                this.modals.approval_log.loading = false;
                            },1000);
                        })
                        .catch( err => {
                            this.$alertNotification(`Can't "${action}"`, "warning");
                            setTimeout(()=>{
                                this.modals.approval_log.loading = false;
                            },1000);
                        })
                    return;
                }
                this.approvalLogObj.action = action;
                if(action === "Reject") {
                    if(!this.approvalLogObj.remark) {
                        this.modals.approval_log.loading = false;
                        return this.$alertNotification("Remark is required", "danger");
                    }
                    this.approvalLogObj.reject = true;
                }
                if(action === "Approval")this.approvalLogObj.approval = true;
                this.$store.dispatch("LMUApprovalRequestController/createApprovalLog",this.approvalLogObj)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('adding', 'approval'));
                        this.modals.approval_log.open = false;
                        this.getItem();
                        this.getNextApprover();
                        this.getApprovalLogs();
                        setTimeout(()=>{
                            this.modals.approval_log.loading = false;
                        },1000);
                    })
                    .catch( err => {
                        this.$alertNotification(`Can't "${action}"`, "warning");
                        setTimeout(()=>{
                            this.modals.approval_log.loading = false;
                        },1000);
                    })
            }
        }
    }
</script>